module.exports = __webpack_public_path__ + "img/avatar.0772e98e.png";